import React, { PureComponent } from 'react';
import classnames from 'classnames';
import _ from 'lodash';
import { GigCards } from '@fiverr-private/gig_card';
import { CurrencyConverter } from '@fiverr-private/futile/lib/number';
import reportEvent, {
    getSellerPageGigCardViewGigImpression,
    getSellerPageGigCardContinueButtonImpression,
    clickOnContinue,
    clickOnViewGig,
    getWideGigBiData
} from '../lib/reportEvent';
import Tabs from './Tabs';
import WithImpressions from '../WithImpressions';
import './index.scss';

export default class WideGig extends PureComponent {
    static get boundFunctions() {
        return [
            'getPriceStr',
            'handleClick'
        ];
    }

    constructor(props) {
        super(props);

        this.currencyConverter = new CurrencyConverter(props.wideGigData.currency);

        this.state = {
            submit: false,
            selectedPackageId: 1
        };

        this.formActionPath = '';
        this.constructor.boundFunctions.forEach((fn) => this[fn] = this[fn].bind(this));
    }

    componentDidMount() {
        setTimeout(() => {
            const { wideGigData, context } = this.props,
                gigId = wideGigData && wideGigData.gig && wideGigData.gig.gig_id;

            this.formActionPath = `${(_.filter(window.fiverrRoutes, (i, k) => (k === 'checkout_customize'))[0] || '/checkout/customize/:gig_id(.:format)').replace(':gig_id(.:format)', gigId)}?ref_ctx_id=${context.pageCtxId}`;
            this.forceUpdate();
        }, 1000);
    }

    getPriceStr(price) {
        return this.currencyConverter.convert(Math.floor(price / 100, 0), {commaSeparate: true});
    }

    handleClick(button, biData) {
        const dataByButton = {
            click_on_continue: clickOnContinue({
                buyerId: 1,
                price: biData.price,
                pageCtxId: biData.pageCtxId,
                gigId: biData.gigId
            }),
            click_on_view_gig: clickOnViewGig({
                buyerId: 1,
                pageCtxId: biData.pageCtxId,
                gigId: biData.gigId
            })
        };

        reportEvent(`seller_last_gig_viewed_card.${button}`, dataByButton[button]);
        return true;
    }

    renderPackage(data, biData) {
        const {
            title,
            description,
            features,
            packageId,
            price,
            url,
            featuresList,
            revisions,
            duration,
            isProGig
        } = data;

        const formattedFeatures = [
            {
                label: i18n.t('wide_gig.delivery', { days: `${duration / 24}`, suffix: duration > 24 ? 's' : '' }),
                included: duration > 0,
                name: 'duration'
            },
            ...features.filter((vla) => featuresList.includes(vla.name))
        ];

        // this item should be second in left column by design.
        revisions && revisions.value > 0 && formattedFeatures.splice(1, 0, {
            ...revisions,
            label: `${revisions.value} ${revisions.label}`
        });

        const sellerPageGigCardContinueButtonImpression = getSellerPageGigCardContinueButtonImpression({
                sellerId: biData.sellerId,
                price: this.getPriceStr(price),
                package: packageId,
                gigId: biData.gigId
            }),
            sellerPageGigCardViewGigImpression = getSellerPageGigCardViewGigImpression({
                sellerId: biData.sellerId,
                package: packageId,
                gigId: biData.gigId
            });

        return (
            <div className="tab-package">
                <h3>{title}</h3>
                <h4>{description}</h4>

                {formattedFeatures.length > 0 && <h3>{i18n.t('wide_gig.whats_included')}</h3>}
                <ul className="extras" style={{height: 26 * Math.ceil(formattedFeatures.length / 2)}}>
                    {formattedFeatures.map((feature) =>
                        (<li key={feature.id} className={classnames([feature.name, { missing: !feature.included }])}>
                            {feature.label.replace('#', feature.value)}
                        </li>))}
                </ul>
                <div className="buttons">
                    <WithImpressions element="a"
                        href={url}
                        onClick={() => this.handleClick('click_on_view_gig', biData)}
                        pageCtxId={biData.pageCtxId}
                        value={sellerPageGigCardViewGigImpression}>
                        {i18n.t('wide_gig.view_gig')}
                    </WithImpressions>
                    <WithImpressions element="button"
                        pageCtxId={biData.pageCtxId}
                        value={sellerPageGigCardContinueButtonImpression}
                        color={isProGig ? 'pro' : 'green'}
                        onClick={() => this.handleClick('click_on_continue', biData)}
                        data-col={packageId}
                        data-package-id={packageId}
                        disabled={this.formActionPath === ''}
                        className="btn-lrg-standard">
                        {i18n.t('wide_gig.continue')} (<span classNames={`js-str-currency js-price js-package-number-${packageId}`}>{this.getPriceStr(price)}</span>)
                    </WithImpressions>
                </div>
            </div>
        );
    }

    render() {
        /* eslint-disable no-unused-vars */
        const {
            props: {
                wideGigData,
                gigs,
                onClose,
                isMobile,
                ...restGigProps
            },
            state: {
                selectedPackageId
            }
        } = this;
        /* eslint-enable no-unused-vars */

        if (_.isEmpty(wideGigData)) { return null; }

        const gig = wideGigData && wideGigData.gig,
            isProGig = gig && gig.is_pro,
            gigId = gig && gig.gig_id,
            gigUrl = gig && gig.gig_url,
            _featuresList = {},
            arr1 = [],
            arr2 = [],
            arr3 = [];

        const biggest = wideGigData.packageList.reduce((acc, cur, i, arr) =>
            arr[acc].features.length > cur.features.length ? acc.features.length : i, 0);

        const allFeatures = wideGigData.packageList[biggest].features.map((item) => ({
            name: item.name,
            label: item.label,
            value: item.value
        }));

        allFeatures.forEach((itm, i) => {
            arr1.push(Object.assign({}, { included: false, ...wideGigData.packageList[0].features[i] }, itm));
            arr2.push(Object.assign({}, { included: false, ...wideGigData.packageList[1].features[i] }, itm));
            arr3.push(Object.assign({}, { included: false, ...wideGigData.packageList[2].features[i] }, itm));
        });

        const newPackageList = [
            { ...wideGigData.packageList[0], features: arr1 },
            { ...wideGigData.packageList[1], features: arr2 },
            { ...wideGigData.packageList[2], features: arr3 }
        ];

        newPackageList.reduce((acc, cur) =>
            cur.features.forEach((item) => {
                const feature = { included: item.included, label: item.label, value: item.value, name: item.name};

                if (_.isArray(_featuresList[item.name])) {
                    _featuresList[item.name] = [..._featuresList[item.name], feature];
                }
                else {
                    _featuresList[item.name] = [feature];
                }
            })
        );

        const featuresList = Object.keys(_featuresList)
            .map((item) => _.some(_featuresList[item], { included: true }) && item)
            .filter(Boolean);

        const wideGigBiData = getWideGigBiData({
            sellerId: restGigProps.user.id,
            text: i18n.t(`wide_gig.${selectedPackageId}`),
            gigId
        });

        return (
            <WithImpressions element="form"
                action={this.formActionPath}
                method="post"
                className="wide-gig"
                pageCtxId={restGigProps.context.pageCtxId}
                value={wideGigBiData}>

                <input type="hidden" name="authenticity_token" value={wideGigData.csrfToken}/>
                <input type="hidden" name="packages[gig_id]" value={gigId}/>
                <input type="hidden" name="packages[package_id]" value={selectedPackageId}/>
                {wideGigData.packageList.length === 1 &&
                <div>
                    <input type="hidden" name="gig_id" value={gigId}/>
                    <input type="hidden" name="quantity" value="1"/>
                </div>}
                <i className="close" onClick={onClose}/>

                <h2>{i18n.t('wide_gig.just_viewed')}</h2>

                {wideGigData.gig &&
                    <GigCards gigs={[wideGigData.gig]} {...restGigProps}/>}

                <div className={classnames('gig-extra-data', {'pro-gig': isProGig})}>
                    <Tabs onChange={(props) => this.setState({selectedPackageId: props.packageId})}>
                        {newPackageList.map((tab, idx) => (
                            <div key={idx}
                                packageId={tab.id}
                                label={i18n.t(`wide_gig.${tab.id}`)}>
                                {this.renderPackage(
                                    {...tab, url: gigUrl, featuresList, isProGig},
                                    {
                                        sellerId: gig && gig.seller_id,
                                        pageCtxId: restGigProps.context.pageCtxId,
                                        price: this.getPriceStr(tab.price),
                                        gigId
                                    }
                                )}
                            </div>
                        ))}
                    </Tabs>
                </div>
            </WithImpressions>
        );
    }
}


// WEBPACK FOOTER //
// ./src/common/WideGig/index.js